import { j as r } from "./AccesRecoveryIcon-CUPieIxT.js";
const t = () => /* @__PURE__ */ r.jsxs("svg", { viewBox: "0 0 60 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M26.4995 15.1327L9.99951 11C9.99253 14.926 11.6994 16.4437 18.9995 17.4286C24.1265 17.8391 26.1766 19.1232 28.9995 22.4796C31.2385 28.6678 31.1575 32.2881 28.9995 39.0102L19.9995 56C27.4376 52.5286 30.4989 48.9324 34.4995 41.7653C41.8206 42.4248 43.9576 39.4897 46.4995 32.1224C44.1915 33.8692 42.8266 35.0979 39.9995 35.3367C37.1967 32.8789 36.2933 31.3577 35.4995 27.0714C35.2164 21.6545 36.0012 19.1463 39.9995 18.3469C43.2826 18.37 47.4995 19.2584 48.4995 19.2584C49.4995 19.2584 50.6182 16.5624 50.9995 15.1327C46.8309 16.0784 44.4206 16.3092 39.9995 16.051L26.4995 15.1327Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "ellipse",
    {
      cx: "3.051",
      cy: "4.81361",
      rx: "3.051",
      ry: "4.81361",
      transform: "matrix(0.821648 0.569995 -0.605546 0.79581 33.0996 3)",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ r.jsx("circle", { cx: "30", cy: "30", r: "29", stroke: "currentColor", strokeWidth: "2" })
] });
export {
  t as F
};
